import { derivativesFor } from '@/lib/imageDerivatives';

/**
 * Industry visual primitives.
 *
 * Extracted from IndustryPage so the hero compositions can use them without a
 * circular import. Behaviour is unchanged — this is a move, not a rewrite.
 */
function ResponsivePhoto({ src, alt, focal, priority, sizes }) {
  const d = derivativesFor(src);
  const common = {
    alt,
    className: 'h-full w-full object-cover',
    style: { objectPosition: focal || '50% 50%' },
    loading: priority ? 'eager' : 'lazy',
    fetchpriority: priority ? 'high' : undefined,
    decoding: 'async',
  };
  if (!d) return <img src={src} {...common} />;

  const set = (ext) => d.widths.map((w) => `${d.base}-${w}.${ext} ${w}w`).join(', ');
  const fallbackWidth = d.widths[d.widths.length - 1];
  return (
    <picture>
      {/* Order matters: the browser takes the first type it supports. */}
      {d.avif && <source type="image/avif" srcSet={set('avif')} sizes={sizes} />}
      {d.webp && <source type="image/webp" srcSet={set('webp')} sizes={sizes} />}
      <source type="image/jpeg" srcSet={set('jpg')} sizes={sizes} />
      <img src={`${d.base}-${fallbackWidth}.jpg`} {...common} />
    </picture>
  );
}

function IndustryVisual({ industry, className = '', rounded = true, priority = false, fill = false, sizes = '100vw' }) {
  return (
    <div className={`overflow-hidden ${fill ? 'absolute inset-0 h-full w-full' : 'relative'} ${rounded ? 'rounded-md' : ''} ${className}`}>
      <ResponsivePhoto
        src={industry.visual.image}
        alt={industry.visual.alt}
        focal={industry.focal}
        priority={priority}
        sizes={sizes}
      />
    </div>
  );
}

export { ResponsivePhoto, IndustryVisual };
